import { useState } from "react";
import "react-notifications/lib/notifications.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Link } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Box, TextField, Card } from "@mui/material";
import Profile from "../Profile";
import { postobj } from "../../apicall/apicall";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import User from "../User";
import {
  form_add,
  buttonStyle,
} from "../../style/style";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Endpoint from "./Endpoint";
import { validated } from "../../apicall/validateform";

export default function Customersetting(props) {
  const [open, setopen] = useState(false);
  const [value, setvalue] = useState("1");

  const [password, setpassword] = useState({
    old_password: "",
    new_password: "",
  });
  const [pwd2, setpwd2] = useState();

  const history = useNavigate();
  const tabChange = (value) => {
    setvalue(value);
  };

  const handlepassword = (e) => {
    const { name, value } = e.target;
    setpassword({
      ...password,
      [name]: value,
    });
  };
  const handlePasswordChange = () => {
    if (validated(password)) {
      if (password.new_password !== password.old_password) {
        if (pwd2 === password.new_password) {
          const url = process.env.REACT_APP_ZEWA_URL + "user/reset-password/";
          const res = postobj(url, password);
          res.then(function (r) {
            if (r["Message"] === "Password changed successfully") {
              NotificationManager.success("Password Changed.", "Success", 2000);
              NotificationManager.remove(NotificationManager.listNotify[0]);
              sessionStorage.setItem("token", "");
              history({ pathname: "/" });
            } else {
              NotificationManager.remove(NotificationManager.listNotify[0]);

              NotificationManager.error("Incorrect password", "Failed", 2000);
              reset();
              setopen(false);
            }
          });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Password did not match", "Failed", 2000);
          reset();
          setopen(false);
        }
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "New password can not be same as old password"
        );
      }
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error(
        "Please fill the form correctly",
        "Failed",
        2000
      );
    }
  };
  const reset = () => {
    setpassword({
      old_password: "",
      new_password: "",
    });
    setpwd2("");
    setopen(false);
  };
  return (
    <div>
      <Card>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList aria-label="lab API tabs example">
              <Tab label="Profile" value={"1"} onClick={() => tabChange("1")} />
              <Tab label="User" value={"2"} onClick={() => tabChange("2")} />
              <Tab
                label="End Point"
                value={"3"}
                onClick={() => tabChange("3")}
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Box>
              <Profile id={props.customer_id} />
              <Link
                href="#"
                variant="body2"
                sx={{ padding: "10px" }}
                onClick={() => {
                  setopen(true);
                }}
              >
                Change password
              </Link>
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <User id={props.customer_id} search={props.search} />
          </TabPanel>
          <TabPanel value="3">
            <Endpoint id={props.customer_id} />
          </TabPanel>
        </TabContext>
      </Card>

      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
        }}
      >
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <TextField
              name="old_password"
              sx={form_add}
              type="password"
              label="Enter Old Password"
              variant="standard"
              value={password.old_password}
              onChange={handlepassword}
            />
            <TextField
              name="new_password"
              sx={form_add}
              type="password"
              label="Enter New Password"
              variant="standard"
              value={password.new_password}
              onChange={handlepassword}
            />
            <TextField
              name="New Password"
              sx={form_add}
              type="password"
              label="Re-enter New Password"
              variant="standard"
              value={pwd2}
              onChange={(e) => {
                setpwd2(e.target.value);
              }}
            />
            <Box m={1} sx={{ marginLeft: "-10px" }}>
              <Button
                color="primary"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={handlePasswordChange}
              >
                Change
              </Button>
              <Button
                color="error"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={reset}
              >
                Cancel
              </Button>
            </Box>
          </FormControl>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <NotificationContainer />
    </div>
  );
}
